// tr_TR language file
// Generated from Feishu Bitable
// Total entries: 450

export default{
    "game_diamond": {
        "title": "Oyun Elması Bilgisi",
        "title0_title": "Oyun Elmasları Nasıl Kazanılır",
        "title0": {
            "txt1": "1. Belirli görevler veya etkinliklerle kazanılır.",
            "txt2": "2. Yükleme ile satın alınamaz."
        },
        "title1_title": "Oyun Elmaslarının Kullanımı",
        "title1": {
            "txt1": "1. Sadece oyun oynamak için kullanılır.",
            "txt2": "2. Oyunda, Oyun Elması normal elmasla aynıdır ve direkt kullanılabilir. Oyun Elması ile kazanılan elmas normaldir.",
            "txt3": "3. Önce oyun elmasları harcanır.",
            "txt4": "4. Elmaslarla birlikte kullanılabilir. Örn: 200 oyun + 800 elmas = 1000 harcama yapılır."
        },
        "title2_title": "Oyun Elmaslarının Süresi",
        "title2": {
            "txt1": "1. Belirli süre geçerli, sonra sistem geri alır."
        }
    },
    "guanxi_gift_rule_title": "Hediye Açıklamaları",
    "guanxi_gift_rule_1": "Bir ilişki hediyesi gönderdikten sonra, alıcı sizinle ilişki kurmayı seçebilir. Aynı anda iki kişi arasında yalnızca bir ilişki olabilir.",
    "guanxi_gift_rule_2": "Her kişi en fazla 3 ilişkiye sahip olabilir ve ilişki türleri aynı olabilir.",
    "guanxi_gift_rule_3": "Bir ilişki kurduktan 24 saat sonra ilişkiyi sonlandırabilirsiniz. İlişkiyi sonlandırdıktan sonra, başka bir ilişki kurmak için başka bir 24 saat beklemeniz gerekir.",
    "not_exist": "Bulunamadı",
    "mbti_intro_title": "MBTI Açıklamaları",
    "mbti_intro_pers": "Kişilik Özellikleri",
    "mbti_intro_love": "Romantik Özellikler",
    "mbti_intro_istj_pers": "Müfettiş Kişilik",
    "mbti_intro_istj_feature": "Ciddi, sessiz, detay odaklı ve titizdirler, düzenli ve yapısal bir yaşamı tercih ederler. Güvenilir ve sorumluluk sahibidirler, kuralları ve gelenekleri takip ederler.",
    "mbti_intro_istj_love": "Aşkta, ISTJ'ler sadık ve istikrarlı partnerlerdir. İlişkileri ciddiye alır, bağlılık ve sorumluluğa odaklanır, ilgilerini kelimelerden çok eylemlerle gösterirler ve derin bağlar kurmak için zamana ihtiyaç duyarlar.",
    "mbti_intro_isfj_pers": "Bakıcı Kişilik",
    "mbti_intro_isfj_feature": "Nazik, kibar ve empatik, başkalarının ihtiyaçlarına karşı sabırlıdırlar. Detay odaklıdırlar ve harika dinleyiciler ve destekçilerdir.",
    "mbti_intro_isfj_love": "İlişkilerde ISFJ'ler derin bir özen gösterir, partnerlerinin hayat detaylarına dikkat eder ve sıcak bir atmosfer yaratır. Genellikle gelenekseldirler ve bağlanmak için zaman alırlar, ancak bağlı kaldıklarında çok sadık olurlar.",
    "mbti_intro_infj_pers": "Mimar Kişilik",
    "mbti_intro_infj_feature": "Derin bir içgörüye ve yaratıcılığa sahip, insanlık ve geleceğe dair derin bir anlayışa sahipler. Zengin bir iç dünyaya sahiptirler, düşünceli ve analitiklerdir.",
    "mbti_intro_infj_love": "INFJ'ler, partnerleriyle zihinsel ve duygusal bağlantı ararlar ve derin konuşmalara değer verirler. Aşkta yüksek idealleri vardır ve aşık olduklarında odaklanmış ve adanmışlardır.",
    "mbti_intro_intj_pers": "Komutan Kişilik",
    "mbti_intro_intj_feature": "Mantıklı, sakin ve kendinden emin, güçlü analitik ve karar alma becerilerine sahiptirler; bilgi ve bilgelik değerlidir ve hedeflerini azimle takip ederler.",
    "mbti_intro_intj_love": "İlişkilerde INTJ'ler aşkı rasyonel bir şekilde ele alır, paylaşılan inanç ve hedeflere değer verirler. Duygularını saklasalar da, düşünceli eylemlerle ilgilerini gösterirler.",
    "mbti_intro_istp_pers": "Zanaatçı Kişilik",
    "mbti_intro_istp_feature": "Pratik, gözlemci ve analitik; özellikle mekanik veya teknik alanlarda uygulamalı görevleri ve pratik sorunları çözmeyi severler.",
    "mbti_intro_istp_love": "ISTP'ler ilişkilerde özgür ruhlu ve spontane olup, partnerleriyle anın tadını çıkarır ve yaşamın zevklerini kısıtlama olmadan paylaşır.",
    "mbti_intro_isfp_pers": "Sanatçı Kişilik",
    "mbti_intro_isfp_feature": "Duyarlı, nazik ve sanatsal; duygusal ve duyusal deneyimlere öncelik verir, kendilerini genellikle yaratıcı yollarla ifade ederler.",
    "mbti_intro_isfp_love": "İlişkilerde ISFP'ler romantik ve düşüncelidir, büyüleyici bir atmosfer yaratmakta ustadırlar ve partnerlerini sürprizlerle mutlu ederler. Duygusal olabilirler ve onları anlayıp destekleyen bir partner ararlar.",
    "mbti_intro_infp_pers": "Arabulucu Kişilik",
    "mbti_intro_infp_feature": "İdealist, nazik ve empatik, zengin bir iç dünyaya ve insan doğasına dair güçlü bir anlayışa sahiptirler; uyum ve güzelliğe değer verirler.",
    "mbti_intro_infp_love": "INFP'ler ilişkilerde derin bir yatırım yapar, güçlü duygusal bağlar ararlar. Duygusal alışverişlere değer verir ve aşk hakkında umut dolu bir bakış açısına sahiptirler.",
    "mbti_intro_intp_pers": "Mantıkçı Kişilik",
    "mbti_intro_intp_feature": "Analitik ve meraklı, bilgiye güçlü bir arzuları vardır; doğruların peşinde bilinmeyen alanları keşfederler.",
    "mbti_intro_intp_love": "İlişkilerde INTP'ler mantıklı yaklaşır, entelektüel ve duygusal uyumu önemserler. Duygularını ifade etmekte çekingen olabilirler ancak tartışmalarla karşılıklı anlayışı geliştirirler.",
    "mbti_intro_estp_pers": "Girişimci Kişilik",
    "mbti_intro_estp_feature": "Enerjik, dışa dönük ve maceraperest; sosyal etkileşimleri ve risk almayı sever, fırsatları aktif bir şekilde değerlendirirler.",
    "mbti_intro_estp_love": "İlişkilerde ESTP'ler canlı ve tutkulu olup, partnerleriyle yeni deneyimler keşfetmeyi severler. Açık sözlüdürler, düşüncelerini ve duygularını doğrudan ifade ederler.",
    "mbti_intro_esfp_pers": "Gösterici Kişilik",
    "mbti_intro_esfp_feature": "Dışa dönük, iyimser ve ifadeci; sosyalleşmeyi ve eğlenceyi sever, enerji ve coşku getirirler.",
    "mbti_intro_esfp_love": "Aşkta, ESFP'ler canlı partnerlerdir, sosyal aktivitelerden keyif alır ve mevcut duygulara odaklanır, partnerlerine neşe ve heyecan getirir.",
    "mbti_intro_enfp_pers": "Kampanya Yapan Kişilik",
    "mbti_intro_enfp_feature": "Yaratıcı, enerjik ve sıcakkanlı, diğerleriyle etkileşimde olmayı sever ve başkalarının duygularını derinlemesine anlarlar.",
    "mbti_intro_enfp_love": "ENFP'ler ilişkilerde güneş gibidir, partnerlerine sıcaklık ve neşe getirir. Romantizm doludurlar, sevgilerini aktif olarak ifade eder ve birlikte güzel anılar yaratmayı dört gözle beklerler.",
    "mbti_intro_entp_pers": "Tartışmacı Kişilik",
    "mbti_intro_entp_feature": "Zeki, esprili ve meraklı; tartışmayı ve yeni fikirler keşfetmeyi severler.",
    "mbti_intro_entp_love": "ENTP'ler, partnerleriyle derin tartışmalar ve münakaşalara girer; aşkta meydan okumayı ve entelektüel gelişimi severler. Genellikle eğlencelidirler, ilişkiye mizah katarlar.",
    "mbti_intro_estj_pers": "Yönetici Kişilik",
    "mbti_intro_estj_feature": "Pratik, kararlı ve kendinden emin; güçlü organizasyon ve liderlik becerilerine sahip olup, verimlilik ve sonuçlara öncelik verirler.",
    "mbti_intro_estj_love": "Aşkta ESTJ'ler iddialı ve kararlı olup, ilgi alanlarını aktif olarak takip eder ve geleceğe yönelik planlar yapar. Sevgilerini pratik destek ve eylemlerle gösterirler.",
    "mbti_intro_esfj_pers": "Konsolos Kişilik",
    "mbti_intro_esfj_feature": "Sıcakkanlı ve arkadaş canlısı, sosyal olup başkalarına değer verirler; gelenek ve aile bağlarını önemserler.",
    "mbti_intro_esfj_love": "ESFJ'ler dikkatli ve şefkatli partnerler olup, uyumlu ve sıcak bir romantik ortam yaratırlar. Genellikle gelenekseldirler, tanıdık flört geleneklerini ve aile onayını takdir ederler.",
    "mbti_intro_enfj_pers": "Kahraman Kişilik",
    "mbti_intro_enfj_feature": "Karizmatik ve kendinden emin, kolayca bağ kurar ve iyi iletişim kurar; başkalarını anlamada ve yönlendirmede etkilidirler.",
    "mbti_intro_enfj_love": "ENFJ'ler coşkulu ve romantik partnerlerdir; sevgilerini açıkça ifade eder ve sıcak bir ortam yaratırlar. Duygusal paylaşıma değer verir ve partnerleriyle derin bir bağ kurmayı amaçlarlar.",
    "mbti_intro_entj_pers": "Yönetici Kişilik",
    "mbti_intro_entj_feature": "Mantıklı, kendine güvenen ve hırslı; güçlü liderlik ve karar verme becerilerine sahip olup, mükemmellik ve başarıya değer verirler, kendileri ve başkaları için yüksek standartlar belirlerler.",
    "mbti_intro_entj_love": "Aşkta ENTJ'ler hedef odaklı olup, aynı düşüncede olan ve karşılıklı büyümeyi destekleyen partnerleri seçerler. Yeterlilik ve ortak hedeflere öncelik verirler, ilişkiyi paylaşılan hedeflerle derinleştirirler.",
    "expressProposalWall": "Teklif Duvarı Kuralları",
    "expressHowTo": "Teklif Duvarına Nasıl Çıkılır",
    "expressSend": "Teklif hediyesini sevdiğinize gönderin, aşkınızı ifade eden metin Teklif Duvarında görünecektir.",
    "expressSend1": "1. \"Hemen Teklif Et\"e dokunun, partiye atlayabilir ve sevgi sözlerinizi göndermek için kullanıcıyı seçebilirsiniz.",
    "expressSend2": "2. Hediyeyi seçin ve kartta ona söylemek istediğiniz sözleri girin.",
    "expressSend3": "3. Hediyeyi göndermek için dokunun ve teklif kartınız duvarda görünecektir.",
    "expressDifferent": "Farklı Teklif Hediyeleri Türleri",
    "expressWeHave": "Aşağıdaki gibi 4 tür Teklif Hediyemiz var.",
    "expressWeHave1": "1. Temel Teklif Hediye Kartı: Basit renkli arka plan.",
    "expressWeHave2": "2. Dekoratif Teklif Hediye Kartı: Dekoratif renkli arka plan.",
    "expressWeHave3": "3. Lüks Teklif Hediye Kartı: Lüks efektli dekoratif arka plan.",
    "expressWeHave4": "4. Gerçek Aşk Teklif Hediye Kartı: Lüks efektli dekoratif arka plan ve şık sunucu genel bildirim çubuğu ile.",
    "expressProposal": "Teklif Kartı Görüntüleme Aralığı",
    "expressProposal1": "1. Odada Teklif Duvarı. (Teklif hediyelerinin üzerindeki çubuğa dokunun)",
    "expressProposal2": "2. An Sayfasının Yanındaki Teklif Duvarı.",
    "diamondDrop1": "1. Bir kullanıcı, bir odada toplamda 50.000'den fazla elmas değerinde hediye gönderdiğinde (şanslı hediyeler değerlerinin 0.1'i olarak hesaplanır), odadaki herkesin açarak elmas alabileceği bir elmas sandığı düşer.",
    "diamondDrop2": "2. Her sandık açılmadan önce 1 dakikalık bir geri sayım süresine sahiptir.",
    "diamondDrop3": "3. Her sandıktaki elmaslar sınırlıdır; geri sayım sona erdiğinde, o sandıktan artık elmas talep edemezsiniz.",
    "diamondDrop4": "4. Sandık kapandıktan sonra, ondan kaç elmas kaptığınızı görmek için tıklayabilirsiniz.",
    "baoxaingxianding": "宝箱限定",
    "cancelAccount": {
        "accountRecoveryContent": "Kurtarma dönemi boyunca, önceki yönteminizle tekrar giriş yapabilir ve hesabınızı kurtarmayı seçebilirsiniz. Kurtarıldığında, tüm hesap mesajlarınızı, seviyelerinizi ve elmaslarınızı geri alacaksınız.",
        "accountRecoveryTitle": "Hesap Kurtarma:",
        "confirmCancellation": "Silmek istediğinizden emin misiniz?",
        "convalescenceContent": "Silme talebi gönderdikten sonra, hesabınız 30 gün boyunca geçici olarak devre dışı bırakılacaktır. Bu süre zarfında, tüm hesap bilgileriniz, seviyeleriniz ve elmaslarınız korunacak, böylece fikrinizi değiştirirseniz sorunsuz bir kurtarma sağlanacaktır.",
        "convalescenceTitle": "Kurtarma Dönemi:",
        "finalContent": "Kurtarma süresi sonunda (silme talebinden itibaren 31 gün) hesabınızı kurtarmayı seçmezseniz, hesabınız ve tüm ilgili verileriniz kalıcı olarak silinecektir. Lütfen silindikten sonra hesabınızın ve verilerinizin kurtarılamayacağını unutmayın.",
        "finalTitle": "Nihai Silme:",
        "reserveContent": "Kurtarma süresi boyunca, hesabınızın verilerini koruyacağız, böylece kaybolmaz veya zarar görmez.",
        "reserveTitle": "Veri Saklama:",
        "statementContent": "Silme Talebi: Hesap silme talebinde bulunduktan sonra, hesabınız 30 günlük bir “kurtarma süresine” girecektir. Bu süre zarfında, hesabınızı herhangi bir noktada kurtarmayı seçebilirsiniz. Bir ajansın parçasıysanız, hesap silme mümkün olmayacaktır.",
        "statementTitle": "Hesap Silme Bildirimi:",
        "userContent": "Hizmetlerimizi kullandığınız için teşekkür ederiz. Bazen hesabınızı silmeniz gerekebileceğini anlıyoruz. Kararınızın iyi düşünüldüğünden emin olmak ve yeniden değerlendirme fırsatı sunmak için, hesap silme sürecini ve ilgili şartları burada açıklıyoruz.",
        "userTitle": "Sayın Kullanıcı:"
    },
    "Countdown": "Geri sayım",
    "Endactivity": "Etkinlik Sona Erdi",
    "eventDetails": "Etkinlik Detayları",
    "eventGifts": "Etkinlik Hediyeleri",
    "eventList": "Etkinlik Lider Tablosu",
    "eventReward": "Etkinlik Ödülleri",
    "eventRewards": {
        "player": "Günlük Aktif Oyuncular",
        "proportion": "Ödül İade Oranı",
        "title": "Etkinlik Ödülleri",
        "txt1": "1. Önceki günün verileri her gün saat 00:00'da (UTC+8) hesaplanır.",
        "txt2": "2. Ödüller, katılımcı sayısına ve odada harcanan gerçek elmaslara (kullanıcı bahisleri eksi kullanıcı kazançları) göre verilir.",
        "txt3": "3. Önceki haftanın verileri her Pazartesi saat 00:00'da (UTC+8) hesaplanır ve ödüller 3 gün içinde dağıtılır.",
        "txt4": "4. Ödül İade Oranı:",
        "txt5": "5. Aktif Oyuncu Tanımı: Bir gün içinde 1.000'den fazla elmas bahis yapan oyuncu."
    },
    "EventRules": "Etkinlik Kuralları",
    "Eventtime": "Etkinlik Zamanı",
    "guild": {
        "guild_certification01": "Ajans Doğrulaması",
        "guild_certification02": "Ajansa Hoş Geldiniz",
        "guild_certification03": "İstihdam Gereksinimleri",
        "guild_certification04": [
            "10 sözleşmeli yayıncılar bir haftada tamamlanmalı",
            "Ajans liderinin kimliği ve diğer gerçek ad belgelerini sağlayabilmeli",
            "Ajans profili, takım tanıtımı, yayıncı bilgileri, yayıncı kazanç kuralları vb. sağlayın"
        ],
        "guild_certification05": "Yukarıdaki gereksinimleri karşılıyorsanız, bilgilerinizi resmi e-postaya gönderin: billionairepte@gmail.com On aylandıktan sonra, bir personel sizinle iletişime geçecektir.",
        "guild_certification06": "Panoya kopyalandı",
        "guild_certification07": "Soruşturma İçin İletişim",
        "guild_certification08": "Kopyala",
        "guild_certification09": "Üyelik Bilgileri",
        "guild_certification10": [
            {
                "title": "1. Üyelik Kuralları",
                "value": [
                    "Başvuru sahipleri, platformda bir üyelik talebi başlatmak için ajans lideri ile anlaşmalıdır. Lider onayladığında, ajansa katkıda bulunan sözleşmeli bir yayıncı olurlar."
                ]
            },
            {
                "title": "2. İstifa Kuralları",
                "value": [
                    "Ajansa katıldıktan sonra ayrılmak için yayıncının ajans lideriyle anlaşması gerekir. Ajans profil sayfasında \"Ajansdan Ayrıl\" a tıklayın. Ajans lideri \"Ayrılmayı Kabul Et\"e tıklamalı ve ardından üye ajansı terk eder.",
                    "Çekilme başarılı olduktan sonra, başka bir ajansa katılmak için başvurabilirsiniz."
                ]
            }
        ],
        "guild_certification11": "Ajans Bilgileri",
        "guild_certification12": [
            {
                "title": "Ajans Kazançları",
                "value": [
                    "Aile odalarındaki kullanıcılar ve yayıncılar hediyeler alır, ajansa katkı sağlarlar.",
                    "Aile odalarında patron saldırıları gerçekleşir.",
                    "Ajansla anlaşma yapan yayıncılar CP odaları oluşturur ve hediye almak ajansa katkı sağlar. (Sözleşmesi olmayan yayıncı, aileye katıldıktan sonra CP odaları oluşturamaz ve aileye katkı sağlayamaz.)"
                ]
            }
        ],
        "InvitationCodeTitle": "Davet Kodu",
        "invite_rules_intriduction": "Davet Kuralları",
        "invite_rules_intriduction_content": [
            "Yayıncılar, kayıt sırasında davet kodunu girerek ajansınıza katılmak ve yayıncı olmak için başvurabilirler.",
            "Kayıt sırasında davet kodunu girmeyen yayıncılar, aile sayfasından ailenize katılmak için başvurabilir ve ardından yayıncı olmak için başvurabilirler."
        ]
    },
    "legend": {
        "title": "Efsanevi Şubat"
    },
    "officialMember": "Resmi Personel",
    "prettyNumber": {
        "text": "Ⅰ. Özel Kimlik Toplama",
        "text1": "Asil Seviye 3 veya daha yüksek bir seviyeye ulaştıktan sonra, seviyenize karşılık gelen bir Özel Kimlik talep edebilirsiniz.",
        "text2": "Daha yüksek seviyeli soylular daha düşük seviyeli bir Özel Kimlik talep edebilirler. Örneğin, Asil 6 bir Seviye 3 Özel Kimlik talep edebilir.",
        "text3": "Soyluluk statünüz sona erdiğinde, Özel Kimlik de kullanılamaz hale gelir. Özel Kimliği kullanmaya devam etmek için soyluluğunuzu yeniden etkinleştirmeniz gerekir.",
        "text5": "Bir Özel Kimlik talep ettikten sonra, aynı veya daha düşük seviyedeki başka bir kimlikle değiştiremezsiniz.",
        "text6": "Bir Özel Kimlik kullanırken daha yüksek bir asil seviyesine ulaşırsanız, hemen daha yüksek seviyeli bir Özel Kimliğe geçebilirsiniz ve orijinal kimlik mağazaya geri dönecektir.",
        "text7": "Örneğin, başlangıçta bir Asil 4 Özel Kimlik talep eden ve ardından Asil 6'ya yükselten bir kullanıcı, Asil 4 veya daha düşük bir Özel Kimliğe geçemez, ancak hemen bir Asil 6 Özel Kimlik talep edebilir.",
        "title": "Açıklama",
        "title1": "Ⅱ. Özel Kimlik Süresi Dolması",
        "title2": "Ⅲ. Özel Kimlik Değişimi"
    },
    "reception": {
        "reception01": "Hediye Liderlik Tablosu Açıklaması",
        "reception02": [
            {
                "title": "Oda Hediye Liderlik Tablosu nedir?",
                "value": [
                    "Oda Hediye Liderlik Tablosu, odada alınan hediyelerin anlık sıralamasıdır",
                    "Oda hediye sayısı = Elmas hediye sayısı"
                ]
            },
            {
                "title": "Oda Hediye Liderlik Tablosu nasıl sıralanır?",
                "value": [
                    "Sıralama, tüm odaların toplam gelirine göre belirlenir, kapsamlı bir şekilde hesaplanır",
                    "Saatlik Liderlik Tablosu: Her saat UMT+8'de sıfırlanır",
                    "Günlük Liderlik Tablosu: Her gün 00:00 UMT+8'de sıfırlanır"
                ]
            },
            {
                "title": "Saatlik Liderlik Tablosunda birinci sırada olan tüm sunucularda yayınlanır",
                "value": [
                    "Saatlik hediye liderlik tablosunda birinci olan oda tüm sunucu odalarında duyurulur"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "Geri",
        "event_rule": "<p>1. Süre Liderlik Tablosu: Etkinlik sırasında kullanıcıların odadaki tüm mikrofon pozisyonlarında harcadıkları toplam süreyi takip eder. En iyi 3 odadaki en iyi 3 katkıda bulunan ödüller alacak.</p><p>2. Cömertlik Liderlik Tablosu: Etkinlik sırasında odada alınan toplam elmas sayısını takip eder. En iyi 3 odadaki en iyi 3 elmas harcayıcı ödüller alacak.</p><p>3. Bu etkinlik haftalık döngü etkinliğidir, liderlik tablosu her hafta sıfırlanır ve yeniden hesaplanır.</p>",
        "last_week": "Geçen Hafta",
        "last_week_rank": "Geçen Haftanın Liderlik Tablosu Detayları",
        "reward": "Ödüller",
        "rich_rank": "Oda Hediye Liderlik Tablosu",
        "rule": "Kurallar",
        "rule_reward": "Kurallar ve Ödüller",
        "time_rank": "Süre Liderlik Tablosu",
        "title": "Aile Odası",
        "top1": "Birinci",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "14 Gün çerçeve",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "14 Gün boyunca etkiler",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "14 Gün çerçeve",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "7 Gün çerçeve",
        "top2": "EN İYİ 2",
        "top3": "EN İYİ 3"
    },
    "TopUpRewards": "Yükleme Ödülleri",
    "treasure_chest": {
        "title": "Hazine Sandığı Hediye Talimatları",
        "value1": "Üç tür hazine sandığı vardır: Ahşap, Gümüş ve Altın.",
        "value2": "Bir hazine sandığı açtığınızda, sandıktan rastgele bir hediye alırsınız ve gönderirsiniz.",
        "value3": "Gönderen, harcanan elmaslara göre deneyim puanı kazanır, alıcı ise sandıktan gelen hediye değeri üzerinden puan ve çekicilik alır.",
        "value4": "1500 elmas fiyatla Ahşap Sandık, aşağıdaki hediyeleri içerir:",
        "value5": "7500 elmas fiyatla Gümüş Sandık, aşağıdaki hediyeleri içerir:",
        "value6": "25000 elmas fiyatla Altın Sandık, aşağıdaki hediyeleri içerir:",
        "value7": "Hazine sandığı hediyeleri yalnızca eğlence ve sosyal etkileşim içindir. Adaleti etkileyen veya ürün hatalarını kullanan herhangi bir işlem kısıtlanacaktır. Tespit edilirse, platform hesabı banlayacak ve yasal işlem yapma hakkını saklı tutar."
    },
    "treasure_name": {
        "name1": "Ahşap Sandık",
        "name2": "Gümüş Sandık",
        "name3": "Altın Sandık",
        "name4": "Olasılık"
    },
    "Value": "Değer:",
    "Webname": {
        "addUid": "UID Ekle",
        "balance": "Bakiye:",
        "Confirm": "Onayla",
        "err_uid": "Geçersiz UID, lütfen yeniden girin",
        "lang": "Dil Seç",
        "Query": "Ara",
        "recharge": "Yükleme Merkezi",
        "Recharge": "Yükleme Merkezi",
        "self": "Kanal",
        "uid": "UID Değiştir",
        "uuserName": "Takma Ad:",
        "Withdrawal": "Çekim"
    },
    "Weekly_Cp": {
        "7days": "7 gün",
        "back": "Geri",
        "countdown": "Bu hafta için geri sayım",
        "day": "Günler",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>Notlar</p><p>1. Tüm ödüller etkinlik sona erdikten sonra 3-5 iş günü içinde hesabınıza yüklenecektir.</p><p>2. Liderlik tablosu, diğer kullanıcılara etkinlik hediyeleri göndermek için harcanan elmasları hesaplar. 1 elmas = 1 CP puanı ve en yüksek CP puanına sahip ilk 3 CP çifti etkinlik ödüllerini alacaktır.</p><p>3. Etkinlik her Pazartesi 00:00'da (UTC+8) sona erer ve önceki haftanın değerleri hesaplanır.</p><p>4. Şanslı hediyelere harcanan elmasların yalnızca %10'u sayılacaktır.</p>",
        "gift": "Etkinlik Hediyeleri",
        "hour": "Saat",
        "last_week": "Geçen hafta",
        "last_week_rank": "Geçen haftanın listesi",
        "minute": "Dakika",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "Ödüller",
        "rule": "Kurallar",
        "rule_reward": "Kurallar ve Ödüller",
        "seconds": "Saniyeler",
        "title": "Ruh Eşi",
        "top1": "Birinci",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "Haftalık Yıldız Avatar Çerçevesi",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "En İyi Destek Avatar Çerçevesi",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "Haftalık Yıldız Kıyafeti",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "İLK 2",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "İLK 3",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "EN İYİ 4-6",
        "top710": "EN İYİ 7-10"
    },
    "Withdrawal": "Para Çekme Talimatları",
    "withdrawalInstructions": {
        "text1": "Para çekme özelliği şu anda yalnızca belirli ülkelerde mevcuttur.",
        "text2": "Para çekme işleminin tamamlanma süresi kanala bağlı olarak değişebilir.",
        "text3": "Döviz kuru dalgalanmaları ve ücretler nedeniyle alınan gerçek tutar, görüntülenen tutardan biraz daha düşük olabilir.",
        "text4": "Günde yalnızca bir kez para çekebilirsiniz.",
        "text5": "Herhangi bir sorunla karşılaşırsanız, lütfen bizimle iletişime geçin."
    },
    "withdrawalLogin": {
        "accountId": "Pix hesap kimliği",
        "accountIdTips": "",
        "accountIdtsa": "Pix hesap kimliği boş olamaz",
        "accountType": "Pix hesap türü",
        "code": "Doğrulama kodu:",
        "Confirm": "Onayla",
        "documentId": "Kişisel kimlik numarası",
        "documentIdTips": "",
        "documentIdtsa": "Kimlik türü boş olamaz",
        "documentType": "Kimlik türü",
        "getAccount": "Hesabı al",
        "getUserId": "Lütfen kullanıcı kimliğini girin",
        "incorrectAccount": "Hatalı hesap",
        "login": "Giriş yap",
        "loginSuccessful": "Başarıyla giriş yapıldı",
        "name": "Pix kullanıcı adı",
        "nameTips": "",
        "nametsa": "Uzunluk 5 ile 100 karakter arasında olmalı",
        "officialGroup": "Herhangi bir sorunuz varsa, lütfen resmi destekle iletişime geçin",
        "pocket": "Pocket Coin bakiyesi",
        "Pocket": "Pocket Coin bakiyesi",
        "Send": "Gönder",
        "text": "Doğrulama kodu uygulama içinde gönderilecek",
        "title": "Kazanç çekme",
        "title2": "Çekme detayları",
        "user_id": "Hesap Kimliği:",
        "Whatsapp": "Hatalı Whatsapp hesabı",
        "WhatsappTips": "",
        "applicationTime": "Talep Tarihi",
        "amount": "Çekim Tutarı",
        "success": "Başarılı",
        "applicationSuccess": "İstek Gönderildi"
    },
    "top1AnchorRewards": "En İyi 1 Yayıncı Ödülü",
    "top2_3AnchorRewards": "En İyi 2-3 Yayıncı Ödülleri",
    "top4_10AnchorRewards": "En İyi 4-10 Yayıncı Ödülleri",
    "top1Icon7day": "Avatar Çerçevesi *7 Gün",
    "top1_2Icon7day": "Giriş Efekti *7 Gün",
    "top3Icon7day": "Avatar Çerçevesi *7 Gün",
    "top1VIPRewards": "İlk 1 VIP Ödülü",
    "top2_3VIPRewards": "En İyi 2-3 VIP Ödülü",
    "top4_10VIPRewards": "En İyi 4-10 VIP Ödülü",
    "relastionship": {
        "des": [
            "",
            "1. İlişki hediyesi gönderdikten sonra, karşı taraf seninle ilişki kurup kurmamayı seçebilir. İki kişi arasında yalnızca bir tür ilişki olabilir.",
            "2. İlişki kurulduktan sonraki 7 takvim günü (UTC+3) içinde yakınlık puanı azalmaz. Koruma süresinden sonra bir gün içinde yakınlık 50 puan artmazsa, ertesi gün 00:00'da %10 azalır (minimum 1). Yakınlık 0’a düşerse ertesi gün 00:00'da ilişki çözülür. 10 gün boyunca yakınlık 50 puan artmazsa, ilişki 00:00'da otomatik olarak sona erer.",
            "3. İlişki kurulduktan 24 saat sonra ilişkiyi bitirebilirsin. Bitirdikten 24 saat sonra tekrar ilişki kurabilirsin.",
            "4. Her kişinin varsayılan olarak 3 ilişki yuvası vardır. Elmas harcayarak daha fazlasını satın alabilirsin, her yuva 99.999 elmas ve en fazla 10 yuva alabilirsin. VIP seviyeni artırarak da yuva sayını artırabilirsin.",
            "VIP Seviyesi",
            "Toplam genişletilebilir ilişki yuvaları"
        ]
    },
    "gift_album_des1": "Yukarıdaki hediyeleri göndermek, onun Haftalık Albüm - \"Dünya Turu\"nu aydınlatmasına ve ödüller kazanmasına yardımcı olabilir.",
    "gift_album_des2": "Yukarıdaki hediyeleri göndermek, onun Kalıcı Albüm - \"Gözde İlgi\"yi aydınlatmasına ve ödüller kazanmasına yardımcı olabilir.",
    "gift_album_des3": "Yukarıdaki hediyeleri göndermek, onun Kalıcı Albüm - \"SVIP Koruması\"nı aydınlatmasına ve ödüller kazanmasına yardımcı olabilir.",
    "gift_album_des4": "Yukarıdaki hediyeleri göndermek, onun Kalıcı Albüm - \"Rüya Düğünü\"nü aydınlatmasına ve ödüller kazanmasına yardımcı olabilir.",
    "gift_album_des5": "Detayları görüntülemek için [Profil] - [Hediye Duvarı] - [Albüm] kısmına gidin",
    "gift_album_des8": "Yukarıdaki hediyeleri göndermek, onun 'Doğum Günü Partisi' kalıcı koleksiyonunu açmasına ve ödüller kazanmasına yardımcı olabilir.",
    "gift_album_des7": "Yukarıdaki hediyeleri göndermek, onun Kalıcı Albüm - \"Oda Yıldızı\"nı aydınlatmasına ve ödüller kazanmasına yardımcı olabilir.",
    "gift_harifata": "Burj Khalifa",
    "gift_sailing_hotel": "Burç El Arap",
    "gift_mosque": "Ulu Cami",
    "gift_abatta": "Abate Kulesi",
    "gift_sphinx": "Sfenks",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "Kalp Atışı",
    "gift_conf_lv2": "Aşka Dair",
    "gift_conf_lv3": "Sınırsız Aşk",
    "gift_conf_lv4": "Yalnız Sen",
    "gift_habibi": "Kardeş",
    "gift_bestie": "Kanka",
    "gift_couple": "Çift",
    "gift_confidant": "Sırdaş",
    "weding_gift_kiss": "Öpücük",
    "weding_gift_ring": "Yüzük",
    "weding_gift_proposal": "Evlilik Teklifi",
    "weding_gift_castle": "Kale",
    "weding_gift_wedding_dress": "Gelinlik",
    "weding_gift_wedding": "Düğün",
    "gift_album_des6": "Kurallar",
    "guild_can_with": "Kullanılabilir",
    "guild_with_ing": "İşleniyor",
    "guild_self_withdraw": "Kendi çekimi",
    "guild_transfer_to_leader": "Ajans Liderine Transfer",
    "guild_salary_to_reseller": "Bayiye Transfer",
    "guild_convert_to_diamond": "Elmasa Çevir",
    "guild_platform_settlement": "Platform Mutabakatı",
    "guild_withdrawal_records": "Çekim Geçmişi",
    "guild_current_withdrawable_pcoin": "Kullanılabilir Coin",
    "guild_transfer_pcoin_amount": "Transfer Tutarı",
    "guild_all": "Tümü",
    "guild_read_before_withdraw": "Çekmeden önce okuyun:",
    "guild_withdraw_note_1": "Gönder",
    "guild_withdraw_note_2": "Çekilebilir Coin yetersiz",
    "guild_min_withdraw_amount": "Gönderilsin mi?",
    "guild_withdraw_note_4": "İptal",
    "guild_appeal_to_platform": "Onayla",
    "guild_submit_application": "Çekim Yöntemi",
    "guild_withdraw_below_min": "Lider Çekimi",
    "guild_confirm_submit_application": "Talep Zamanı",
    "guild_freeze_notice": "İşlem Süresi",
    "guild_communicate_with_leader": "Reddedilme Nedeni",
    "guild_cancel": "İade Tutarı",
    "guild_confirm": "Beklemede",
    "guild_withdrawal_method": "Tamamlandı",
    "guild_leader_withdraw": "Reddedildi",
    "guild_status_timeout_rejected": "Süre doldu (Otomatik reddedildi)",
    "guild_apply_time": "Yalnızca son 3 ay",
    "guild_process_time": "Çekimle ilgili sorular?",
    "guild_rejection_reason": "Destekle İletişime Geç",
    "guild_amount_refunded": "Doğrulanmış Bayi",
    "guild_status_pending": "Sadece Bayiler",
    "guild_status_completed": "Kullanılabilir",
    "guild_status_rejected": "Transfer Tutarı",
    "guild_show_last_3_months": "Tahmini Varış",
    "guild_withdrawal_question": "Başarılı",
    "guild_contact_customer_service": "Elmasa Çevir",
    "guild_certified_reseller": "Çevrilebilir Coin",
    "guild_not_reseller_cannot_transfer": "Çevir",
    "guild_current_withdrawable": "Çevrildi",
    "guild_transfer_amount": "Uzlaşan Coin",
    "guild_estimated_arrival": "Talep gönderildi",
    "guild_read_before_operation": "1. Lütfen bayi ile çevrimdışı ödeme detaylarını önceden teyit edin",
    "guild_transfer_note_1": "2. Transferler yalnızca bayiye yapılabilir",
    "guild_transfer_note_2": "Transferi Onayla",
    "guild_confirm_transfer": "Gönderilsin mi?",
    "guild_confirm_submit_transfer": "{n} jeton düşülecek",
    "guild_deduct_pcoin_receive_diamond": "Lütfen ödeme detaylarını bayiyle görüşün",
    "guild_communicate_with_reseller": "İşlem Başarılı",
    "guild_operation_success": "Elmasa Çevir",
    "guild_exchange_diamond": "Çevrilebilir Coin",
    "guild_current_exchangeable_pcoin": "Çevir",
    "guild_exchange": "Çevirme Başarılı",
    "guild_exchange_success": "Bekleyen Coin",
    "guild_settlement_pcoin_amount": "1. Lütfen çekim yöntemini Operasyon Ekibi ile önceden teyit edin",
    "guild_settlement_note_1": "2. Ödemeler gelecek Pazartesi işlenecek",
    "guild_settlement_note_2": "3. Minimum çekim tutarı: {n} Coin",
    "guild_settlement_min_amount": "Talep gönderildi",
    "guild_application_submitted": "{n} Coin düşülecek",
    "guild_deduct_pcoin": "Lütfen ödeme detaylarını Operasyon Ekibi ile görüşün",
    "guild_user_not": "Kullanıcı bulunamadı",
    "guild_please_enter_amount": "Tutar girin",
    "guild_insufficient_balance": "Yetersiz bakiye",
    "guild_please_enter_reseller_uid": "RESELLER UID girin",
    "guild_please_search_reseller_first": "Lütfen önce RESELLER’ı arayın",
    "guild_select_hand": "Bir işlem seçin",
    "guild_ci_hand": "1. Bu işlem Lonca Liderine bir talep gönderir,",
    "guild_offline_transfer_funds": "ödeme lider tarafından çevrimdışı yapılacaktır",
    "guild_ci_hand_2": "2. Lütfen ödeme yöntemini önceden liderle teyit edin (banka kartı / USDT vb.)",
    "guild_ci_hand_3": "3. Minimum çekim tutarı {n} Coin",
    "guild_ci_hand_4": "4. Lider ödemeyi onayladığı halde almadıysanız, lütfen sohbet kayıtlarını saklayın ve",
    "guild_ci_hand_5": "platforma itiraz gönderin",
    "guild_ci_hand_6": "Sistem {n} Coin’i lider işlem yapana kadar dondurur",
    "guild_ci_hand_7": "Lütfen çekim kanalını liderle teyit edin; ödeme manuel yapılır",
    "guild_tips_1": "Çekilebilir Coin minimumun altında",
    "guild_contact_service": "Ödeme düzenlemesi için operasyon ekibiyle iletişime geçin",
    "guild_reseller_tips": "Coin’lerin karşı kullanıcının elmasına dönüştü. Ödeme için onunla konuş.",
    "gift_collection_detail_permanent_birthday": "Doğum Günü Partisi",
    "gift_collection_detail_permanent_roomstar": "Oda Yıldızı",
    "gift_holy_sword": "Kutsal Kılıç",
    "gift_volcano": "Volkan",
    "gift_emperor_come_world": "İmparator",
    "gift_castle_of_love": "Aşk Kalesi",
    "gift_Immortal_god_war": "Savaş Tanrısı",
    "gift_king_of_gods": "Gücün Kralı",
    "birthday_gift_cybergift": "Siber Hediye",
    "birthday_gift_wish": "Dilek Lambası",
    "birthday_gift_cake": "Altın Pasta",
    "birthday_gift_lion": "Aslan Lütfu",
    "birthday_gift_biggift": "Lüks Hediye",
    "guild_reseller_tips": "Coin’lerin karşı kullanıcının elmasına dönüştü. Ödeme için onunla konuş.",
    "guild_page_fee": "Her işlem için $2 ücret",
    "guild_page_saudi": "Suudi Arabistan",
    "guild_page_morocco": "Fas",
    "guild_page_bank": "Banka",
    "guild_page_name": "Ad (İngilizce)",
    "guild_page_name_english": "Ad yalnızca İngilizce olmalı",
    "guild_page_bank_number": "Banka hesap numarası",
    "guild_page_enter": "Geçerli banka hesap numarası girin",
    "guild_page_address": "Adres (İngilizce)",
    "guild_page_address_english": "Adres yalnızca İngilizce olmalı",
    "guild_page_country": "Ülke/Bölge",
    "guild_page_holder_name": "Hesap sahibi adı",
    "guild_page_sa": "Örn: SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "Format: Sokak, Bölge, Şehir, Eyalet, Ülke",
    "guild_page_minimum": "3. Minimum çekim tutarı {n} Coin"
}
